import { render } from "./customCustomer.vue?vue&type=template&id=67926e94"
import script from "./customCustomer.vue?vue&type=script&lang=js"
export * from "./customCustomer.vue?vue&type=script&lang=js"

import "./customCustomer.vue?vue&type=style&index=0&id=67926e94&lang=scss"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__